import React from 'react';
import { GripVertical, Calendar, SortAsc } from 'lucide-react';
import { Button, Text, Group } from '@mantine/core';
import './SortDropdownNew.css';

export type SortType = 'rank' | 'dueDate' | 'alphabetical';

interface SortDropdownProps {
  value: SortType;
  onChange: (value: SortType) => void;
  compact?: boolean;
}

const getSortConfig = (sortType: SortType) => {
  switch (sortType) {
    case 'rank':
      return {
        icon: GripVertical,
        name: 'Rank',
        description: 'drag to reorder'
      };
    case 'dueDate':
      return {
        icon: Calendar,
        name: 'Due Date',
        description: 'by duedate'
      };
    case 'alphabetical':
      return {
        icon: SortAsc,
        name: 'A-Z',
        description: 'alphabetically'
      };
    default:
      return {
        icon: GripVertical,
        name: 'Rank',
        description: 'drag to reorder'
      };
  }
};

export const SortDropdownNew: React.FC<SortDropdownProps> = ({ 
  value, 
  onChange, 
  compact = false
}) => {
  const sortOptions: SortType[] = ['rank', 'dueDate', 'alphabetical'];
  
  const handleCycle = () => {
    const currentIndex = sortOptions.indexOf(value);
    const nextIndex = (currentIndex + 1) % sortOptions.length;
    onChange(sortOptions[nextIndex]);
  };

  const currentConfig = getSortConfig(value);
  const CurrentIcon = currentConfig.icon;

  return (
    <Button
      variant="subtle"
      color="gray"
      size={compact ? "xs" : "sm"}
      onClick={handleCycle}
      leftSection={<CurrentIcon size={14} />}
      className="sort-button-new"
      styles={{
        root: {
          backgroundColor: 'transparent !important'
        }
      }}
    >
      {compact ? (
        <Text size="xs" c="dimmed">{currentConfig.description}</Text>
      ) : (
        <Group gap={4}>
          <Text size="sm">Sort:</Text>
          <Text size="sm" fw={500}>{currentConfig.name}</Text>
          <Text size="xs" c="dimmed">({currentConfig.description})</Text>
        </Group>
      )}
    </Button>
  );
};

export default SortDropdownNew;
